<template>
	<div class="row" @click="$sidebar.displaySidebar(false)">
        <div class="col-xl-8 mb-5 mb-xl-0">
            <div class="card shadow">

				<div class="card-body">
					<div class="">
						<h4 class="">テストユーザー<a class="float-right btn btn-primary" :href="siteUrl" target="_blank">テストユーザー登録</a></h4>
						<small class="form-text text-muted mb-3 text-right">このブラウザで現在のユーザーをテストユーザーとして登録する</small>
					</div>
					<div class="loading"  v-show="loading">受信中...</div>

					<div class="el-table__body-wrapper table-responsive">
						<table class='table table-striped el-table__body' v-if="!loading">
							<thead>
								<tr class="el-table__row">
									<th scope="col">ID</th>
									<th scope="col">ユーザーID</th>
									<th scope="col">サブスクリプションID</th>
									<th scope="col">ユーザー名</th>
									<th scope="col">OS</th>
									<th scope="col">ブラウザ</th>      
								</tr>
							</thead>
							<tbody>

							<tr v-for="(testuser, key) in testuserList" :key="key" class="el-table__row">
									<td class="el-table_1_column_1"> {{ testuser.id }} </td>
									<td  class="el-table_1_column_2"> {{ testuser.user_id }} </td>
									<td  class="el-table_1_column_3"> {{ testuser.push_subscriptions_id }} </td>
									<td  class="el-table_1_column_4"> {{ testuser.name }} </td>
									<td  class="el-table_1_column_4"> {{ testuser.os_family }} ( {{ testuser.os_version }} )</td>
									<td  class="el-table_1_column_4"> {{ testuser.browser_family }} ( {{ testuser.browser_version }} ) </td>			
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
        </div>
    </div>       
</template>


<script>
//import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

export default {
    components: { moment},
     props: ['UsersList', 'SiteData', 'OthersData'],
	data() {
		return {
			siteId:null,
			// Our data object that holds the Laravel paginator data
			testuserList: {},
			siteInfo:{},
			others:{},
			loading:false,
			siteUrl:""
		}
	},
	
	filters: {
    moment
  },

	computed: {
		
    },
    mounted() {
		this.siteId = window.PushL.site_id;
		this.testuserList = JSON.parse(this.UsersList)
		this.siteInfo = JSON.parse(this.SiteData)
		this.others = JSON.parse(this.OthersData)
		this.siteUrl = "https://" +this.siteInfo.site_domain+ "?hash="+this.others.hash;
		console.log(this.siteId)
		//this.getResults();
    },
	
	methods: {
	
	     formatToLocal(date) {
	        return moment.utc(date).local().format('YYYY年MM月DD日 HH:mm:ss');
           // return moment(date).isSame(moment().clone().startOf('day'), 'd');
        },
		// Our method to GET results from a Laravel endpoint
		/*getResults(page = 1) {
			if(this.lastpage != null && this.lastpage < page) return;
			axios.get('/sentlist?page=' + page)
				.then(response => {
					this.notificationList = response.data;
					this.lastpage = response.data.last_page
				});
		},*/
		getPercentage(notification) {
			return ((notification.read_cnt/notification.sent_cnt) * 100).toFixed(2);
		},

 		initializeSelection () {
		    this.selectedMonth = new Date().getMonth() + 1;
			this.selectedYear = new Date().getFullYear();
	    },
		onMonthChange(event) {
	      this.selectedMonth = parseInt(event.target.value);
	    },
	    onYearChange(event) {
	      this.selectedYear = parseInt(event.target.value);
		},
		// Our method to GET results from a Laravel endpoint
		getResults() {
			if(!this.selectedYear || !this.selectedMonth) {
				this.initializeSelection();
			}
			this.siteId = window.PushL.site_id;
			
			axios.get('/'+ this.siteId+'/sentlist/'+ this.selectedYear + '/' + this.selectedMonth)
				.then(response => {
					console.log(response.data)
					this.notificationList = response.data;
					this.total = response.data.total;
					this.loading = false;
					
				});
		},

		getUserList () {
		this.loading = true;
	      this.getResults();
		},
		nl2br(text) {
			console.log("aaaa")
			return text.replace(/\n/g, "<br>")
		}
	}

}
</script>

<style scoped>
    p {
    	text-align: center;
    }
    p span{
        font-weight:bold;
        padding: 0 5px;
    	font-size: 4em;
    }
	
	h4 {
		display:inline-block;
		width: 100%;
	}
	
    ul {
    float:left;
    padding:0;
    }
    li {
	float: left;
	margin: 5px 10px;
    }

    .loading {
        padding-top: 150px;
         padding-bottom: 150px;
	    font-size: 1.3em;
    }
    thead {
        background-color: #f8f9fe;
    	color: #181818;
    }
   
    
</style>